window.workspaceApp = workspaceApp

document.addEventListener('alpine:init', () => {
	Alpine.data('workspaceApp', workspaceApp);
});

function workspaceApp() {
	return {
		activeNavTab: 'workspaces', // 'workspaces' | 'mytasks'
		currentUserId: 'u-1', // Alex Johnson

		isWorkspaceSheetOpen: false,
		isListsSheetOpen: false,
		isTaskSheetOpen: false,
		isNewListSheetOpen: false,
		isMembersSheetOpen: false,
		isSearchVisible: false,
		isMyTasksSearchVisible: false,
		showCompleted: true,
		showMyCompleted: true,

		activeWorkspaceId: 'ws-2',
		activeListId: 'all',

		quickTaskTitle: '',
		searchQuery: '',
		myTasksSearchQuery: '',
		statusFilter: 'all',
		assigneeFilter: 'all',

		selectedTask: null,
		newCommentText: '',
		editingCommentId: null,
		editingCommentContent: '',
		newListTitle: '',


		// Dummy Workspaces
		workspaces: [
			{ id: 'ws-1', title: "Alex's Personal Space", type: 'private', role: 'owner', icon: '👤' },
			{ id: 'ws-2', title: '🚀 Mobile App Sprint', type: 'group', role: 'admin', icon: '🚀' },
			{ id: 'ws-3', title: '🛒 Family & Home', type: 'group', role: 'member', icon: '🏠' }
		],

		// Dummy Discovered Members
		members: [
			{ id: 'u-1', name: 'Alex Johnson', username: 'alex', avatar: 'AJ', color: 'bg-teal-700 text-white', role: 'admin', online: true, wsIds: ['ws-1', 'ws-2', 'ws-3'] },
			{ id: 'u-2', name: 'Sarah Chen', username: 'sarah_c', avatar: 'SC', color: 'bg-amber-700 text-white', role: 'owner', online: true, wsIds: ['ws-2', 'ws-3'] },
			{ id: 'u-3', name: 'Marcus Bell', username: 'mbell', avatar: 'MB', color: 'bg-sky-700 text-white', role: 'member', online: false, wsIds: ['ws-2'] },
			{ id: 'u-4', name: 'Elena Rostova', username: 'elena_r', avatar: 'ER', color: 'bg-rose-700 text-white', role: 'member', online: true, wsIds: ['ws-2'] },
			{ id: 'u-5', name: 'David Kim', username: 'dkim', avatar: 'DK', color: 'bg-purple-700 text-white', role: 'member', online: false, wsIds: ['ws-2', 'ws-3'] }
		],

		// Dummy Lists
		lists: [
			{ id: 'l-1', wsId: 'ws-2', title: '📥 Inbox' },
			{ id: 'l-2', wsId: 'ws-2', title: '🏃 Sprint 24' },
			{ id: 'l-3', wsId: 'ws-2', title: '🐛 Bugs' },
			{ id: 'l-4', wsId: 'ws-2', title: '💡 Ideas' },
			{ id: 'l-5', wsId: 'ws-1', title: 'Tasks' },
			{ id: 'l-6', wsId: 'ws-3', title: 'Groceries' },
			{ id: 'l-7', wsId: 'ws-3', title: 'Home Repairs' }
		],

		// Dummy Tasks with status, due dates, assignees, and comments across workspaces
		tasks: [
			{
				id: 't-1',
				wsId: 'ws-2',
				listId: 'l-2',
				title: 'Verify HMAC-SHA256 signature on Telegram initData',
				description: 'Ensure bot secret key token derivation matches Telegram auth protocol.',
				status: 'in_progress',
				dueDate: '2026-08-29',
				assigneeIds: ['u-1', 'u-2'],
				comments: [
					{ id: 'c-1', userId: 'u-2', content: 'Checked telemetry, HMAC verification is fast.', time: '2h ago' }
				]
			},
			{
				id: 't-2',
				wsId: 'ws-2',
				listId: 'l-2',
				title: 'Batch group chat notifications to prevent mention spam',
				description: 'Consolidated message format for Telegram broadcasts.',
				status: 'todo',
				dueDate: '2026-09-02',
				assigneeIds: ['u-1', 'u-3'],
				comments: []
			},
			{
				id: 't-3',
				wsId: 'ws-2',
				listId: 'l-3',
				title: 'Fix touch tap targets for 360px viewport',
				description: 'Ensure minimum 44px tap targets for mobile usability.',
				status: 'todo',
				dueDate: '2026-08-27', // Overdue
				assigneeIds: ['u-1', 'u-4'],
				comments: []
			},
			{
				id: 't-4',
				wsId: 'ws-2',
				listId: 'l-2',
				title: 'Build Workspace Switcher and Member presence pills',
				description: 'Responsive Alpine state for switching workspaces.',
				status: 'completed',
				dueDate: '2026-08-28',
				completedAt: '4:15 PM',
				assigneeIds: ['u-1'],
				comments: []
			},
			{
				id: 't-5',
				wsId: 'ws-2',
				listId: 'l-4',
				title: 'Explore Telegram WebApp CloudStorage synchronization',
				description: 'Evaluate fallback mechanics for desktop web clients.',
				status: 'todo',
				dueDate: null,
				assigneeIds: ['u-1'],
				comments: []
			},
			{
				id: 't-6',
				wsId: 'ws-1',
				listId: 'l-5',
				title: 'Renew domain and SSL certificate',
				description: 'Annual registration renewal for personal services.',
				status: 'todo',
				dueDate: '2026-08-29',
				assigneeIds: ['u-1'],
				comments: []
			},
			{
				id: 't-7',
				wsId: 'ws-3',
				listId: 'l-6',
				title: 'Pick up oat milk and cold brew coffee',
				description: 'From organic grocery store.',
				status: 'todo',
				dueDate: '2026-08-29',
				assigneeIds: ['u-1'],
				comments: []
			}
		],

		// --- Workspace Helpers ---
		getActiveWorkspace() {
			return this.workspaces.find(w => w.id === this.activeWorkspaceId) || this.workspaces[0];
		},

		getWorkspaceTitle(wsId) {
			const ws = this.workspaces.find(w => w.id === wsId);
			return ws ? ws.title : 'Workspace';
		},

		getWorkspaceIcon(wsId) {
			const ws = this.workspaces.find(w => w.id === wsId);
			return ws ? ws.icon : '📋';
		},

		getActiveWorkspaceMembers() {
			return this.members.filter(m => m.wsIds.includes(this.activeWorkspaceId));
		},

		getMembersForWorkspace(wsId) {
			return this.members.filter(m => m.wsIds.includes(wsId || this.activeWorkspaceId));
		},

		getWorkspaceLists() {
			return this.lists.filter(l => l.wsId === this.activeWorkspaceId);
		},

		getListsForWorkspace(wsId) {
			return this.lists.filter(l => l.wsId === (wsId || this.activeWorkspaceId));
		},

		getActiveListName() {
			if (this.activeListId === 'all') return 'All Lists';
			const list = this.lists.find(l => l.id === this.activeListId);
			return list ? list.title : 'List';
		},

		getActiveListCount() {
			if (this.activeListId === 'all') {
				return this.getWorkspaceTasks().length;
			}
			return this.getTasksForList(this.activeListId).length;
		},

		getWorkspaceTasks() {
			return this.tasks.filter(t => t.wsId === this.activeWorkspaceId);
		},

		getTasksForList(listId) {
			return this.tasks.filter(t => t.wsId === this.activeWorkspaceId && t.listId === listId);
		},

		getListName(listId) {
			const list = this.lists.find(l => l.id === listId);
			return list ? list.title : 'General';
		},

		getMember(userId) {
			return this.members.find(m => m.id === userId);
		},

		getFilteredTasks() {
			let filtered = this.getWorkspaceTasks();

			if (this.activeListId !== 'all') {
				filtered = filtered.filter(t => t.listId === this.activeListId);
			}

			if (this.searchQuery.trim()) {
				const q = this.searchQuery.toLowerCase();
				filtered = filtered.filter(t => 
					t.title.toLowerCase().includes(q) || 
					(t.description && t.description.toLowerCase().includes(q))
				);
			}

			if (this.statusFilter === 'active') {
				filtered = filtered.filter(t => t.status !== 'completed');
			} else if (this.statusFilter === 'completed') {
				filtered = filtered.filter(t => t.status === 'completed');
			}

			if (this.assigneeFilter === 'mine') {
				filtered = filtered.filter(t => t.assigneeIds.includes(this.currentUserId));
			}

			return filtered;
		},

		// --- My Tasks Cross-Workspace Helpers ---
		getMyTasks() {
			let my = this.tasks.filter(t => t.assigneeIds.includes(this.currentUserId));
			if (this.myTasksSearchQuery.trim()) {
				const q = this.myTasksSearchQuery.toLowerCase();
				my = my.filter(t => t.title.toLowerCase().includes(q) || (t.description && t.description.toLowerCase().includes(q)));
			}
			return my;
		},

		getMyTasksOverdue() {
			return this.getMyTasks().filter(t => t.status !== 'completed' && this.isOverdue(t));
		},

		getMyTasksToday() {
			const today = new Date().toISOString().split('T')[0];
			return this.getMyTasks().filter(t => t.status !== 'completed' && t.dueDate === today);
		},

		getMyTasksUpcoming() {
			const today = new Date().toISOString().split('T')[0];
			return this.getMyTasks().filter(t => t.status !== 'completed' && t.dueDate && t.dueDate > today);
		},

		getMyTasksNoDueDate() {
			return this.getMyTasks().filter(t => t.status !== 'completed' && !t.dueDate);
		},

		jumpToWorkspace(wsId) {
			this.activeWorkspaceId = wsId;
			this.activeListId = 'all';
			this.activeNavTab = 'workspaces';
		},

		switchWorkspace(wsId) {
			this.activeWorkspaceId = wsId;
			this.activeListId = 'all';
		},

		// --- Task Actions ---
		toggleTaskStatus(task) {
			if (task.status === 'completed') {
				task.status = 'todo';
				task.completedAt = null;
			} else {
				task.status = 'completed';
				const now = new Date();
				task.completedAt = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
			}
		},

		addQuickTask() {
			if (!this.quickTaskTitle.trim()) return;

			const targetListId = this.activeListId === 'all' 
				? (this.getWorkspaceLists()[0]?.id || 'l-1')
				: this.activeListId;

			const newTask = {
				id: 't-' + Date.now(),
				wsId: this.activeWorkspaceId,
				listId: targetListId,
				title: this.quickTaskTitle.trim(),
				description: '',
				status: 'todo',
				dueDate: null,
				assigneeIds: [],
				comments: []
			};

			this.tasks.unshift(newTask);
			this.quickTaskTitle = '';
		},

		openNewTaskModal() {
			this.selectedTask = {
				id: '',
				wsId: this.activeNavTab === 'mytasks' ? this.workspaces[0].id : this.activeWorkspaceId,
				listId: this.activeNavTab === 'mytasks' ? (this.getListsForWorkspace(this.workspaces[0].id)[0]?.id || '') : (this.activeListId === 'all' ? (this.getWorkspaceLists()[0]?.id || 'l-1') : this.activeListId),
				title: '',
				description: '',
				status: 'todo',
				dueDate: '',
				assigneeIds: this.activeNavTab === 'mytasks' ? [this.currentUserId] : [],
				comments: []
			};
			this.newCommentText = '';
			this.isTaskSheetOpen = true;
		},

		openTaskDetail(task) {
			this.selectedTask = JSON.parse(JSON.stringify(task));
			this.newCommentText = '';
			this.isTaskSheetOpen = true;
		},

		saveTaskDetail() {
			if (!this.selectedTask) return;

			if (!this.selectedTask.id) {
				this.selectedTask.id = 't-' + Date.now();
				this.tasks.unshift(this.selectedTask);
			} else {
				const idx = this.tasks.findIndex(t => t.id === this.selectedTask.id);
				if (idx !== -1) {
					this.tasks[idx] = JSON.parse(JSON.stringify(this.selectedTask));
				}
			}

			this.isTaskSheetOpen = false;
			this.selectedTask = null;
		},

		deleteTask(task) {
			this.tasks = this.tasks.filter(t => t.id !== task.id);
		},

		toggleAssignee(userId) {
			if (!this.selectedTask) return;
			if (this.selectedTask.assigneeIds.includes(userId)) {
				this.selectedTask.assigneeIds = this.selectedTask.assigneeIds.filter(id => id !== userId);
			} else {
				this.selectedTask.assigneeIds.push(userId);
			}
		},

		isAssigned(userId) {
			return this.selectedTask && this.selectedTask.assigneeIds.includes(userId);
		},

		addComment() {
			if (!this.newCommentText.trim() || !this.selectedTask) return;

			if (!this.selectedTask.comments) {
				this.selectedTask.comments = [];
			}

			this.selectedTask.comments.push({
				id: 'c-' + Date.now(),
				userId: this.currentUserId,
				content: this.newCommentText.trim(),
				time: 'Just now'
			});

			this.newCommentText = '';
		},

		startEditComment(comment) {
			this.editingCommentId = comment.id;
			this.editingCommentContent = comment.content;
		},

		cancelEditComment() {
			this.editingCommentId = null;
			this.editingCommentContent = '';
		},

		saveEditComment(comment) {
			if (!this.editingCommentContent.trim()) return;
			comment.content = this.editingCommentContent.trim();
			this.editingCommentId = null;
			this.editingCommentContent = '';
		},


		createNewList() {
			if (!this.newListTitle.trim()) return;

			const newList = {
				id: 'l-' + Date.now(),
				wsId: this.activeWorkspaceId,
				title: this.newListTitle.trim()
			};

			this.lists.push(newList);
			this.activeListId = newList.id;
			this.newListTitle = '';
			this.isNewListSheetOpen = false;
		},

		isOverdue(task) {
			if (!task.dueDate || task.status === 'completed') return false;
			const today = new Date().toISOString().split('T')[0];
			return task.dueDate < today;
		},

		formatDueDate(dateStr) {
			if (!dateStr) return '';
			const today = new Date().toISOString().split('T')[0];
			if (dateStr === today) return 'Today';
			if (dateStr < today) return 'Overdue';
			return dateStr;
		},

		getDueDateClass(task) {
			if (task.status === 'completed') return 'task-chip--muted';
			if (this.isOverdue(task)) return 'task-chip--overdue';
			const today = new Date().toISOString().split('T')[0];
			if (task.dueDate === today) return 'task-chip--today';
			return 'task-chip--due';
		}
	};
}
